import { useI18nStore } from '../../lib/i18n';
const tt = (k, p) => useI18nStore.getState().t(`startStopAdmin.${k}`, p);
const pad = (n) => String(n).padStart(2, '0');
export const localIso = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
const addDays = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); return x; };
const monday = (d) => addDays(d, -((d.getDay() + 6) % 7));

export const PRESETS = [
  ['today', 'pToday', (n) => [n, n]],
  ['yesterday', 'pYesterday', (n) => [addDays(n, -1), addDays(n, -1)]],
  ['last7', 'pLast7', (n) => [addDays(n, -6), n]],
  ['thisWeek', 'pThisWeek', (n) => [monday(n), n]],
  ['lastWeek', 'pLastWeek', (n) => [addDays(monday(n), -7), addDays(monday(n), -1)]],
  ['thisMonth', 'pThisMonth', (n) => [new Date(n.getFullYear(), n.getMonth(), 1), n]],
  ['lastMonth', 'pLastMonth', (n) => [new Date(n.getFullYear(), n.getMonth() - 1, 1), new Date(n.getFullYear(), n.getMonth(), 0)]],
];

export function DatePresets({ from, to, onPick }) {
  const now = new Date();
  return (
    <div className="flex flex-wrap gap-1" data-testid="ss-date-presets">
      {PRESETS.map(([k, label, fn]) => {
        const [a, b] = fn(now).map(localIso);
        const on = a === from && b === to;
        return (
          <button key={k} type="button" onClick={() => onPick(a, b)} data-testid={`ss-preset-${k}`}
            className={`h-8 px-3 rounded-full text-xs font-semibold transition-colors ${on ? 'bg-slate-900 text-white' : 'bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700 text-slate-600 hover:bg-slate-50'}`}>
            {tt(label)}
          </button>
        );
      })}
    </div>
  );
}
